export const SET_EDGES = "SET_EDGES" ;
export const SET_NODES = "SET_NODES" ;
export const SET_FLOW_VISIBILITY = "SET_FLOW_VISIBILITY";
export const SET_SIDEBAR_TYPE = "SET_SIDEBAR_TYPE";
export const UPDATE_NODE_DATA = "UPDATE_NODE_DATA" ;
export const DELETE_NODE = "DELETE_NODE";
export const DELETE_EDGE = "DELETE_EDGE";
export const SELECTED_NODE = "SELECTED_NODE";
export const CHANGE_NODE_TYPE = "CHANGE_NODE_TYPE";
export const DELTE_SUBSEQUENT_NODES = "DELTE_SUBSEQUENT_NODES";
export const UPDATE_POSITIONS = "UPDATE_POSITIONS";
export const UPDATE_POSTION_OF_NODE = "UPDATE_POSTION_OF_NODE";
export const SET_ACTION_TYPE="SET_ACTION_TYPE";
export const UPDATE_AN_EDGE = "UPDATE_AN_EDGE";
export const UPDATE_A_NODE = "UPDATE_A_NODE";
export const UPDATE_STEP_COUNT = "UPDATE_STEP_COUNT";
export const FORM_FIELDS = "FORM_FIELDS";
export const ACTION_FORM_FIELDS = "ACTION_FORM_FIELDS";
export const SET_WORKFLOWS = "SET_WORKFLOWS"

